var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAwesomeDirections(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-directions",
    "data-name": "Icon awesome-directions",
    d: "M23.56,10.937,13.063.44a1.5,1.5,0,0,0-2.126,0L.44,10.937a1.5,1.5,0,0,0,0,2.126l10.5,10.5a1.5,1.5,0,0,0,2.126,0l10.5-10.5a1.5,1.5,0,0,0,0-2.126Zm-4.733.589-3.947,3.644a.375.375,0,0,1-.63-.276V12.375H9.75v3a.375.375,0,0,1-.375.375h-1.5a.375.375,0,0,1-.375-.375v-3.75a1.5,1.5,0,0,1,1.5-1.5h5.25V7.606a.375.375,0,0,1,.63-.276l3.947,3.644A.375.375,0,0,1,18.826,11.525Z",
    fill: "#fca300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAwesomeDirections);
export default __webpack_public_path__ + "static/media/Icon-awesome-directions.0fe64d8ccc95e310e4675979edb97c88.svg";
export { ForwardRef as ReactComponent };